import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const QuestionCircle = ({
  width = 32,
  height = 32,
  className,
  color,
  decorative = false,
  ariaLabel = "Help",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.666664 14.0003C0.666664 6.63653 6.6362 0.666992 14 0.666992C17.5362 0.666992 20.9276 2.07175 23.4281 4.57224C25.9286 7.07272 27.3333 10.4641 27.3333 14.0003C27.3333 21.3641 21.3638 27.3337 14 27.3337C6.6362 27.3337 0.666664 21.3641 0.666664 14.0003ZM2 14.0003C2 20.6277 7.37258 26.0003 14 26.0003C20.6274 26.0003 26 20.6277 26 14.0003C26 7.37291 20.6274 2.00033 14 2.00033C7.37258 2.00033 2 7.37291 2 14.0003ZM12.4 20.0003H14V22.4003H12.4V20.0003ZM18 11.7337C18.3076 10.9726 18.4442 10.1533 18.4 9.33366C18.5088 8.24457 18.1163 7.16511 17.3333 6.40033C16.2351 5.79349 14.9853 5.51575 13.7333 5.60033C12.3742 5.6214 11.0259 5.84612 9.73333 6.26699V7.33366H10.4L13.4667 6.93366C14.3888 6.84275 15.3171 7.02842 16.1333 7.46699C16.6794 7.92826 16.9759 8.6201 16.9333 9.33366C16.9773 9.98105 16.8387 10.6278 16.5333 11.2003C16.0828 11.8494 15.5443 12.4327 14.9333 12.9337C14.2444 13.4853 13.6183 14.1113 13.0667 14.8003C12.6808 15.2497 12.4474 15.8099 12.4 16.4003C12.4121 16.8567 12.5023 17.3077 12.6667 17.7337H13.8667V16.9337C13.9201 16.3666 14.1025 15.8193 14.4 15.3337L16.2667 13.6003C16.9508 13.0861 17.5378 12.454 18 11.7337Z"
        fill="#CC7A00"
      />
    </svg>
  );
};


